import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useState } from 'react';

import { useRequestAnimationFrame } from '@/package';

type useRemainTimeProps = {
  expireIn: Dayjs;
  enabled?: boolean;
};

export const useRemainTime = ({
  expireIn,
  enabled = true,
}: useRemainTimeProps) => {
  const [remainTimeText, setRemainTimeText] = useState('00:00');

  useRequestAnimationFrame(() => {
    if (!enabled) return;
    const current = dayjs();
    const diff = Math.ceil(expireIn.diff(current) / 1e3);

    if (diff < 0) return;

    const minute = Math.floor(diff / 60);
    const second = `${diff - minute * 60}`.padStart(2, '0');

    setRemainTimeText(`${`${minute}`.padStart(2, '0')}:${second}`);
  }, [expireIn, enabled]);

  return { remainTimeText };
};
